import api from "../../store/services/api";

export const listWhatsAppInstances = () => api.get("/whatsapp/instance/");

export const createWhatsAppInstance = (data) =>
  api.post("/whatsapp/instance/", data, {
    headers: { "Content-Type": "application/json" },
  });

export const getWhatsAppQRCode = (id) =>
  api.get(`/whatsapp/instance/${id}/qrcode/`);

export const getWhatsAppStatus = (id) =>
  api.get(`/whatsapp/instance/${id}/status/`);

export const disconnectWhatsApp = (id) =>
  api.post(`/whatsapp/instance/${id}/disconnect/`);

export const deleteWhatsAppInstance = (id) =>
  api.delete(`/whatsapp/instance/${id}/`);

export const getWhatsAppNotificationConfig = (instanceId) =>
  api.get(`/whatsapp/instance/${instanceId}/notifications/config/`);

export const setWhatsAppNotificationConfig = (instanceId, data) =>
  api.put(`/whatsapp/instance/${instanceId}/notifications/config/`, data, {
    headers: { "Content-Type": "application/json" },
  });

export const getWhatsAppPresets = () =>
  api.get("/whatsapp/notifications/presets/");

export const sendWhatsAppTest = (instanceId, data) =>
  api.post(`/whatsapp/instance/${instanceId}/notifications/test/`, data, {
    headers: { "Content-Type": "application/json" },
  });

export const getWhatsAppInstanceRestaurants = (instanceId) =>
  api.get(`/whatsapp/instance/${instanceId}/restaurants/`);

export const setWhatsAppInstanceRestaurants = (instanceId, restaurantIds, handlesPosOrders) =>
  api.put(`/whatsapp/instance/${instanceId}/restaurants/`, {
    restaurant_ids: restaurantIds,
    handles_pos_orders: handlesPosOrders,
  });
